module.exports = __webpack_public_path__ + "static/media/lock.10c8c524.png";